// 社員グループ新規作成・編集画面
import React, { useState, useCallback, useEffect } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Grid,
  Theme,
  Button,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogActions
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import './List.css';
import { useHistory, Redirect, useLocation } from 'react-router-dom';
import 'date-fns';
import { useRecoilState } from 'recoil';
import { mainBlueColor, btnColor, isLoggedIn } from '../GlobalState';
import {
  createEmployeeGroup,
  getEmployeeGroupListDetails,
  deleteEmployeeGroupById,
  updateEmployeeGroup
} from '../apicalls/employeeGroup';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import LoadingComponent from '../components/LoadingComponent';

export const CreateEmployeeGroup: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 60,
        alignItems: 'center'
      },
      textMainContainer2: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 300,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        height: 40,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },

      inputMainContainer2: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 300,
        alignItems: 'center',
        width: '100%'
      },

      inputMainContainer1: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 80,
        alignItems: 'center',
        width: '100%'
      },
      textMainContainer1: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 80,
        alignItems: 'center'
      },

      textMainContainer11: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '100%',
        height: 60,
        alignItems: 'center'
      },

      textContainer1: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input1: {
        height: 60,
        width: '100%'
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        height: 48,
        width: '100%'
      }
    })
  );

  const classes = useStyles();
  const history: any = useHistory();
  const matches2 = useMediaQuery('(min-width:900px)');
  const location: any = useLocation();

  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [roleSale, setRoleSale] = useState<number>(0);
  const [roleClient, setRoleClient] = useState<number>(0);
  const [rolePartner, setRolePartner] = useState<number>(0);
  const [roleConstruction, setRoleConstruction] = useState<number>(0);
  const [roleProduct, setRoleProduct] = useState<number>(0);
  const [roleAccount, setRoleAccount] = useState<number>(0);

  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const handleClickOpenAlert = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const saveEmployeeGroupDetails = () => {
    if (name.trim() === '') {
      setErrorMessage('社員グループ名を入力してください。');
      setOpen(true);
      // } else if (email.trim() === "") {
      //   setErrorMessage("メールアドレスを入力してください。");
      //   setOpen(true);
      // } else if (
      //   !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      //     email.trim()
      //   )
      // ) {
      //   setErrorMessage("無効なメールアドレスです。");
      //   setOpen(true);
    } else {
      createEmployeeGroup(
        name.trim(),
        email.trim(),
        roleSale,
        roleClient,
        rolePartner,
        roleConstruction,
        roleProduct,
        roleAccount
      ).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setErrorMessage(data.message);
              setOpenSuccess(true);
              setTimeout(() => {
                history.goBack();
              }, 2000);
            }
          }
        }
      });
    }
  };

  const deleteSelectedEmployeeGroup = () => {
    deleteEmployeeGroupById(history.location.state.state).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setOpenSuccess(true);
            setErrorMessage(data.message);
            setTimeout(() => {
              history.goBack();
            }, 1500);
          }
        }
      }
    });
  };

  const updateEmployeeGroupDetails = () => {
    if (name.trim() === '') {
      setErrorMessage('社員グループ名を入力してください。');
      setOpen(true);
      // } else if (email.trim() === "") {
      //   setErrorMessage("メールアドレスを入力してください。");
      //   setOpen(true);
      // } else if (
      //   !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      //     email.trim()
      //   )
      // ) {
      //   setErrorMessage("無効なメールアドレスです。");
      //   setOpen(true);
    } else {
      updateEmployeeGroup(
        history.location.state.state,
        name.trim(),
        email.trim(),
        roleSale,
        roleClient,
        rolePartner,
        roleConstruction,
        roleProduct,
        roleAccount
      ).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setErrorMessage(data.message);
              setOpenSuccess(true);
            }
          }
        }
      });
    }
  };

  const getListOfEmployeeGroupListDetails = useCallback(() => {
    getEmployeeGroupListDetails(history.location.state.state).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setName(data.data.name);
            setEmail(data.data.email);
            if (data.data.role_sale === true) {
              setRoleSale(1);
            }
            if (data.data.role_client === true) {
              setRoleClient(1);
            }
            if (data.data.role_partner === true) {
              setRolePartner(1);
            }
            if (data.data.role_construction === true) {
              setRoleConstruction(1);
            }
            if (data.data.role_product === true) {
              setRoleProduct(1);
            }
            if (data.data.role_accounts === true) {
              setRoleAccount(1);
            }
            setLoading(false);
          }
        }
      }
    });
  }, [changeLoggedInData, history.location.state]);

  useEffect(() => {
    if (history.location.state) {
      getListOfEmployeeGroupListDetails();
    }
  }, [getListOfEmployeeGroupListDetails, history.location.state]);

  // パンくずリスト表示パターン(編集)
  let patternName = 'employee_groups_edit';

  // 新規作成画面のモードの場合
  if (location.pathname.match('create')) {
    // パンくずリスト表示パターン(新規)
    patternName = 'employee_groups_create';
  }

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <>
      <AppBarComponent patternName={patternName} />
      {loading && history.location.state ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            overflow: 'hidden',
            backgroundColor: '#F5F5F5',
            minHeight: window.innerHeight
          }}
        >
          <div style={{ margin: 15 }}>
            <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
              <Alert onClose={handleClose} severity='error'>
                {errorMessage}
              </Alert>
            </Snackbar>

            <Snackbar
              open={openSuccess}
              autoHideDuration={4000}
              onClose={handleCloseSuccess}
            >
              <Alert onClose={handleCloseSuccess} severity='success'>
                {errorMessage}
              </Alert>
            </Snackbar>

            <Dialog
              open={openAlert}
              onClose={handleCloseAlert}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
            >
              <DialogTitle id='alert-dialog-title'>
                {'社員グループを削除しますか？'}
              </DialogTitle>
              <DialogActions>
                <Button onClick={handleCloseAlert} color='primary'>
                  キャンセル
                </Button>
                <Button
                  onClick={() => {
                    handleCloseAlert();
                    deleteSelectedEmployeeGroup();
                  }}
                  color='primary'
                  autoFocus
                >
                  削除
                </Button>
              </DialogActions>
            </Dialog>

            <div style={{ backgroundColor: '#FFFFFF', paddingRight: 15 }}>
              <div className='table-top-container-customer'>
                <div
                  style={{
                    fontWeight: 'bold',
                    padding: 15,
                    paddingBottom: 0,
                    fontSize: 24
                  }}
                >
                  {history.location.state
                    ? '社員グループ編集'
                    : '社員グループ作成'}
                </div>
              </div>

              <Grid container>
                <Grid item xs={matches2 ? 5 : 12}>
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        社員グループ名<span>*</span>
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <input
                          value={name}
                          maxLength={30}
                          placeholder='30文字以内'
                          onChange={text => {
                            setName(text.target.value);
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>

                  {
                    // <Divider
                    //   style={{ backgroundColor: "#CCCCCC", marginLeft: 15 }}
                    // />
                    //
                    // <div className={classes.subContainer}>
                    //   <div className={classes.textMainContainer}>
                    //     <div className={classes.textContainer}>
                    //       メールアドレス<span>*</span>
                    //     </div>
                    //   </div>
                    //   <div className={classes.inputMainContainer}>
                    //     <div className={classes.inputContainer}>
                    //       <input
                    //         value={email}
                    //         onChange={(text) => {
                    //           setEmail(text.target.value);
                    //         }}
                    //         className={classes.input}
                    //       />
                    //     </div>
                    //   </div>
                    // </div>
                    // <Divider
                    //   style={{ backgroundColor: "#CCCCCC", marginLeft: 15 }}
                    // />
                    //
                    // <div>
                    //   <div className={classes.subContainer}>
                    //     <div className={classes.textMainContainer2}>
                    //       <div className={classes.textContainer}>利用機能</div>
                    //     </div>
                    //     <div className={classes.inputMainContainer2}>
                    //       <div className={classes.inputContainer}>
                    //         <div>
                    //           <div style={{ alignItems: "center" }}>
                    //             <Checkbox
                    //               onClick={() => {
                    //                 if (roleSale === 0) {
                    //                   setRoleSale(1);
                    //                 } else {
                    //                   setRoleSale(0);
                    //                 }
                    //               }}
                    //               checked={roleSale === 1 ? true : false}
                    //               style={{ color: buttonColor }}
                    //               inputProps={{
                    //                 "aria-label": "uncontrolled-checkbox",
                    //               }}
                    //             />
                    //             売上管理
                    //           </div>
                    //           <div style={{ alignItems: "center" }}>
                    //             <Checkbox
                    //               onClick={() => {
                    //                 if (roleClient === 0) {
                    //                   setRoleClient(1);
                    //                 } else {
                    //                   setRoleClient(0);
                    //                 }
                    //               }}
                    //               checked={roleClient === 1 ? true : false}
                    //               style={{ color: buttonColor }}
                    //               inputProps={{
                    //                 "aria-label": "uncontrolled-checkbox",
                    //               }}
                    //             />
                    //             顧客データ
                    //           </div>
                    //           <div style={{ alignItems: "center" }}>
                    //             <Checkbox
                    //               onClick={() => {
                    //                 if (rolePartner === 0) {
                    //                   setRolePartner(1);
                    //                 } else {
                    //                   setRolePartner(0);
                    //                 }
                    //               }}
                    //               checked={rolePartner === 1 ? true : false}
                    //               style={{ color: buttonColor }}
                    //               inputProps={{
                    //                 "aria-label": "uncontrolled-checkbox",
                    //               }}
                    //             />
                    //             業者データ
                    //           </div>
                    //           <div style={{ alignItems: "center" }}>
                    //             <Checkbox
                    //               onClick={() => {
                    //                 if (roleConstruction === 0) {
                    //                   setRoleConstruction(1);
                    //                 } else {
                    //                   setRoleConstruction(0);
                    //                 }
                    //               }}
                    //               checked={roleConstruction === 1 ? true : false}
                    //               style={{ color: buttonColor }}
                    //               inputProps={{
                    //                 "aria-label": "uncontrolled-checkbox",
                    //               }}
                    //             />
                    //             工事台帳
                    //           </div>
                    //           <div style={{ alignItems: "center" }}>
                    //             <Checkbox
                    //               onClick={() => {
                    //                 if (roleProduct === 0) {
                    //                   setRoleProduct(1);
                    //                 } else {
                    //                   setRoleProduct(0);
                    //                 }
                    //               }}
                    //               checked={roleProduct === 1 ? true : false}
                    //               style={{ color: buttonColor }}
                    //               inputProps={{
                    //                 "aria-label": "uncontrolled-checkbox",
                    //               }}
                    //             />
                    //             商品発注書「照合済み」更新
                    //           </div>
                    //           <div style={{ alignItems: "center" }}>
                    //             <Checkbox
                    //               onClick={() => {
                    //                 if (roleAccount === 0) {
                    //                   setRoleAccount(1);
                    //                 } else {
                    //                   setRoleAccount(0);
                    //                 }
                    //               }}
                    //               checked={roleAccount === 1 ? true : false}
                    //               style={{ color: buttonColor }}
                    //               inputProps={{
                    //                 "aria-label": "uncontrolled-checkbox",
                    //               }}
                    //             />
                    //             アカウント管理
                    //           </div>
                    //         </div>
                    //       </div>
                    //     </div>
                    //   </div>
                    // </div>
                    // <Divider
                    //   style={{ backgroundColor: "#CCCCCC", marginLeft: 15 }}
                    // />
                  }
                </Grid>
              </Grid>

              <div style={{ height: 10, backgroundColor: '#FFFFFF' }}></div>
            </div>
          </div>
          <div style={{ height: 80 }} />
        </div>
      )}
      <FooterComponent />

      <div
        className='save-btn-container'
        style={{
          backgroundColor: '#FFFFFF',
          position: 'fixed',
          bottom: 0,
          width: '100%',
          display: 'flex',
          justifyContent: 'space-around',
          padding: 20
        }}
      >
        <div style={{ flex: '1' }} />
        <div style={{ textAlign: 'center', flex: '1' }}>
          <Button
            style={{
              paddingLeft: 50,
              paddingRight: 50,
              backgroundColor: buttonColor
            }}
            variant='contained'
            color='primary'
            onClick={() => {
              if (history.location.state) {
                updateEmployeeGroupDetails();
              } else {
                saveEmployeeGroupDetails();
              }
            }}
          >
            保存
          </Button>
        </div>
        <div style={{ textAlign: 'right', flex: '1', paddingRight: 20 }}>
          {history.location.state && (
            <div>
              <Button
                style={{
                  marginRight: 10,
                  color: '#758283',
                  backgroundColor: '#F5F5F5',
                  marginBottom: !matches2 ? 10 : 0
                }}
                variant='contained'
                color='secondary'
                onClick={handleClickOpenAlert}
                startIcon={<DeleteIcon />}
              >
                削除
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
